import type { ReactNode } from "react";

import { Chip } from "@/components/Chip/Chip";

type Props = {
  title: ReactNode;
};

export const TripTag = ({ title }: Props) => {
  return (
    <Chip label={title} color="accent-softer" shape="full" size="medium" />
  );
};
